import { Fragment, useContext } from "react";
import { useNavigate } from "react-router";
import { Button } from "rizzui";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import cn from "../../../utils/classNames";
import KoReasonsList from "./list/KoReasonsList";

const KoReasonsListWrapper = () => {

    const { userCan } = useContext(PrivilegeContext);
    const navigate = useNavigate();

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de estados' },
        { name: 'Motivos de KO', href: menuRoutes.states.path + menuRoutes.states.koReasons },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de motivos de KO" breadcrumb={breadCrumb}>
                    {
                        userCan('create_ko_reasons', 'ko_reasons') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { navigate(menuRoutes.states.path + menuRoutes.states.koReasons + '/create') }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear motivo de KO
                            </Button>
                        )
                    }

                </PageHeader>
                <KoReasonsList />
            </FiltersProvider>
        </Fragment>
    );
}

export default KoReasonsListWrapper;
